<template>
    <div class="instagram-page-selector">
        <div class="page-card">
            <div class="page-card-header">
                <div class="page-card-header-title">{{ $t("message.selectAnIgAccount") }}</div>
            </div>
            <div class="page-card-body">
                <div class="page-card-body-content">
                    <div class="page-card-body-content-item" v-for="page in getInstagramPages()" :key="page.id">
                        <div class="page-card-body-content-item-image">
                            <img :src="page.instagram_business_account.profile_picture_url" alt="page image" />
                        </div>
                        <div class="page-card-body-content-item-info">
                            <div class="page-card-body-content-item-info-name">
                                {{ page.instagram_business_account.name }}
                            </div>
                            <div class="page-card-body-content-item-info-username">
                                {{ page.instagram_business_account.username }}
                            </div>
                        </div>
                        <div class="page-card-body-content-item-action">
                            <SupsisButton primary @click="() => changeValue(page)" :disabled="isConnectedBefore(page)">
                                <span v-if="isConnectedBefore(page)">Connected</span>
                                <span v-else>{{ $t("chatbotv2.select") }}</span>
                            </SupsisButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import SupsisButton from "../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "InstagramPageSelector",
    components: {
        SupsisButton,
    },
    props: {
        pages: {
            type: Array,
            required: true,
            default: () => [
                {
                    instagram_business_account: {
                        id: "17841445369776035",
                        name: "Supsis Canlı Destek & Chatbot Sistemleri",
                        username: "supsis.ai",
                        profile_picture_url:
                            "https://scontent-fra5-2.xx.fbcdn.net/v/t51.2885-15/424988982_1749597825527975_9000045867713007175_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=7d201b&_nc_ohc=4CFn120MESkAX8SVN_B&_nc_ht=scontent-fra5-2.xx&edm=AGaHXAAEAAAA&oh=00_AfD6bbxTUu2esFPKLuOREdEvAJhjtJU3yupIZGpgZ-OEDQ&oe=6610B681",
                    },
                    id: "102824852658606",
                    name: "Supsis Live Chat",
                    access_token:
                        "EABl8ZBkKhRk8BOwyN9JZBlELUwMVJ0pNszFYdQZCLd3toZCXNITMxELjziBWZCJy3s6JohTHXyXvzjX4iIxeWSAZCiQg7NkFKIL1ZAfHctTV994OpgAv99G14OZAUGNOgYBQqPXXXvphdc8zWo2twFT7hjixjjZBdUGLaKsjOSF7Nw0IHGuowNJOrBNxGoEnJpaIZD",
                    page_token: "Supsis-Live-Chat-102824852658606",
                    category: "Ürün/Hizmet",
                    is_webhooks_subscribed: true,
                    business: {
                        id: "949683942879804",
                        name: "SUPSIS Live Chat",
                    },
                    is_messenger_platform_bot: true,
                    picture: {
                        data: {
                            url: "https://scontent-fra3-2.xx.fbcdn.net/v/t39.30808-1/411518572_322177064053101_4252746555509854509_n.jpg?stp=cp0_dst-jpg_p50x50&_nc_cat=104&ccb=1-7&_nc_sid=5f2048&_nc_ohc=LGL6fHfRIDEAX_FWgsb&_nc_ht=scontent-fra3-2.xx&edm=AGaHXAAEAAAA&oh=00_AfDMe7zVA7kQgjUUWACFI1LZFhxaRe4GhjMsLm2xITBaSA&oe=66108649",
                        },
                    },
                    website: "https://supsis.com/",
                },
                {
                    instagram_business_account: {
                        id: "17841442232089312",
                        name: "SOFTCAND YAZILIM HİZMETLERİ",
                        username: "softcand_yazilim",
                        profile_picture_url:
                            "https://scontent-fra3-1.xx.fbcdn.net/v/t51.2885-15/145985753_1039089636577663_6575791795885884148_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=7d201b&_nc_ohc=V6dKnXO-gC0AX9QjwjI&_nc_ht=scontent-fra3-1.xx&edm=AGaHXAAEAAAA&oh=00_AfApiyJZh6nDL5f3HnKH0bsamciZW5Ca16I_EO5OuGekuw&oe=6610A8B9",
                    },
                    id: "105109601616345",
                    name: "Softcand Yazılım Hizmetleri",
                    access_token:
                        "EABl8ZBkKhRk8BO2pKkdDraQhSiZCZARN45WZCwiAOtmrO464mI9PAIvevhCBWZBczQ56tqdxAgvhLgwHLXtbbpOB04pm746WnrYvfmH2EAPCf5vb8eQltGpoodMPpjkbSiG6TNtlQl5RD2PWDUKkawu9xRsUXDFUh0o2f726MJStzfZAyd4cmgkIaZCdG35020ZD",
                    page_token: "Softcand-Yazılım-Hizmetleri-105109601616345",
                    category: "Yazılım Şirketi",
                    is_webhooks_subscribed: true,
                    is_messenger_platform_bot: true,
                    picture: {
                        data: {
                            url: "https://scontent-fra3-1.xx.fbcdn.net/v/t39.30808-1/301574660_442520351230567_8511325515344995233_n.jpg?stp=cp0_dst-jpg_p50x50&_nc_cat=105&ccb=1-7&_nc_sid=5f2048&_nc_ohc=9xHT_aLkjUsAX8QCowb&_nc_oc=AdhAF5fC8YX_vxyTBr45LgZInb9OL9tIRnQC-VhTnpNMS8SDy0ZGKcrH2pgxHTof4oY&_nc_ht=scontent-fra3-1.xx&edm=AGaHXAAEAAAA&oh=00_AfCbSCM04gufOarsIjOlze8OfDa6k4sFi3oFA01ZHJb5cQ&oe=66108D77",
                        },
                    },
                    website: "http://softcand.com/",
                },
                {
                    id: "166869696992454",
                    name: "Petkolik",
                    access_token:
                        "EABl8ZBkKhRk8BOZBcPJEfAMArBesgZAcP0z4wdBdl1Ir55fewdlDYLd61TiRZC8kRRFKLlxrd9pnWkjB3UkW0uZBDFnRBZB43sudHLzwbLQFKiQHhyfTrxXaImbaZAZBCFDcDe5qKCZCZC0QEWnXDPZAcSxc2w4ecmQe66OMf8t1WuCamr9SaXkZAHTTv2feILe7BmsZD",
                    page_token: "petkolik",
                    category: "Evcil Hayvan Dükkanı",
                    is_webhooks_subscribed: false,
                    business: {
                        id: "942601592500883",
                        name: "Petkolik",
                    },
                    description:
                        "Evcil hayvanınız hayatınıza girdiği andan itibaren geçen zamanı bir düşünün... Yavru bir köpek, yardıma muhtaç bir sokak kedisi, şahane bir akvaryum ya da neşeyle şakıyan bir muhabbet kuşu .Hangisi olursa olsun hissedilen şey hep aynidir: koşulsuz bir sevgi..karşılık beklemeden tutkuyla bağlanılan cinsten..işte bu sevginin bir sözlük karşılığı olsaydı ne olurdu diye düşündük ve petkolik.com böyle doğdu..\n \nPetkolik.com herşeyden önce sizi anlayan, evcil hayvanınızın hayat döngüsü boyunca her ihtiyacını 9000 i aşkın ürün çeşidiyle karşılayan ve müşteri memnuniyetini ön planda tutan bir evcil hayvan platformu olma hedefiyle yola çıkmıştır.\n \nBu yolda sizlere bambaşka bir alışveriş deneyimi yaratmak adına petkolik ailesi olarak çok çalışmaya devam edeceğiz..",
                    is_messenger_platform_bot: true,
                    picture: {
                        data: {
                            url: "https://scontent-fra3-1.xx.fbcdn.net/v/t39.30808-1/252837075_289375343190529_8211635310715817465_n.jpg?stp=cp0_dst-jpg_p50x50&_nc_cat=103&ccb=1-7&_nc_sid=5f2048&_nc_ohc=VhRvl6BTBboAX_1SVuG&_nc_ht=scontent-fra3-1.xx&edm=AGaHXAAEAAAA&oh=00_AfBCfuHVadK1_bFrAFMV36NLdJfdW7Z1be8BZNIpPsPtgA&oe=66109E9F",
                        },
                    },
                    website: "http://www.petkolik.com/",
                },
            ],
        },
        value: String,
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({
            instagramChannels: (state) => state.channel.channels.filter((x) => x.type === "instagram"),
        }),
    },
    methods: {
        getInstagramPages() {
            return this.pages.filter((x) => !!x.instagram_business_account);
        },
        changeValue(page) {
            this.clone = page;
        },
        isConnectedBefore(page) {
            return this.instagramChannels.some((x) => {
                const id = x.payload?.page?.instagram_business_account?.id;
                const currentId = page?.instagram_business_account?.id;
                return id === currentId;
            });
        },
    },
    created() {
        this.clone = _.cloneDeep(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(value) {
                if (_.isEqual(value, this.clone)) return;
                this.clone = _.cloneDeep(value);
            },
        },
        clone: {
            deep: true,
            handler(value) {
                this.$emit("input", value);
            },
        },
    },
});
</script>

<style scoped lang="scss">
.instagram-page-selector {
    .page-card {
        border-radius: 8px;
        overflow: hidden;

        .page-card-header {
            background-color: #f5f5f5;
            padding: 16px;

            .page-card-header-title {
                font-size: 18px;
                font-weight: 500;
            }
        }

        .page-card-body {
            .page-card-body-content {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                gap: 16px;
                padding: 16px;

                .page-card-body-content-item {
                    background-color: #fff;
                    border-radius: 8px;
                    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                    display: flex;
                    padding: 16px;

                    .page-card-body-content-item-image {
                        flex: 0 0 80px;

                        img {
                            border-radius: 50%;
                            height: 80px;
                            width: 80px;
                        }
                    }

                    .page-card-body-content-item-info {
                        flex: 1;
                        padding: 0 16px;

                        .page-card-body-content-item-info-name {
                            font-size: 16px;
                            font-weight: 500;
                        }

                        .page-card-body-content-item-info-username {
                            color: #666;
                            font-size: 14px;
                        }
                    }

                    .page-card-body-content-item-action {
                        flex: 0 0 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }
    }
}
</style>
